// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 15H15.4141L12 18.4141L8.58594 15H2V2H22V15ZM6 8V10H18V8H6Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 20V22H2V20H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-abstract-filled')
export default class AbstractFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'abstract-filled',
    }
  }
}
